import { render, staticRenderFns } from "./limitsReserch2.vue?vue&type=template&id=b08081a0&"
import script from "./limitsReserch2.vue?vue&type=script&lang=js&"
export * from "./limitsReserch2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports